import identity from "ramda/es/identity";
import prop from "ramda/es/prop";
import propOr from "ramda/es/propOr";
import { createSelector } from 'reselect';
import { REDUCER_NAME } from '../../constants/urls';
/**
 * Get urls from state
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getUrls(state)
 *
 */ export const getUrls = createSelector(identity, propOr({}, REDUCER_NAME));
/**
 * Get prop from urls
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getFromUrls('baseUrl')(state)
 *
 */ export const getFromUrls = (propName)=>createSelector(getUrls, prop(propName));
/**
 * Get base url
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getBaseUrl(state)
 *
 */ export const getBaseUrl = getFromUrls('baseUrl');
/**
 * Get base url with appended postfix
 *
 * @documented
 * @category Selector
 * @example
 *
 *    getBaseWithPostfix('/upload')(state)
 *
 */ export const getBaseWithPostfix = (postfix)=>(state)=>`${getBaseUrl(state)}${postfix}`;
